import React from 'react';
import PropTypes from 'prop-types';
import { MobileHealthCareChart } from '../../HealthCareChart/HealthCareChartContainer';
import MobileTopNavSmallView from '../../MobileTopNav/MobileTopNavSmallView';
import { MobileActionStepsV2 } from '../../FinancialPlan/ActionStepsV2/ActionStepsV2Container';
import { MobileExplanations } from '../../FinancialPlan/Explanations/ExplanationsContainer';
import { createCustomPropType, isNumeric, isUuid } from '../../../js/app/react/validators';
import MobileEditGoalButton from '../MobileEditGoalButton/MobileEditGoalButtonContainer';

const MobileEducationView = (props) => {
  const {
    fpId, clientId, chartData, chartTitle, hasGoal,
  } = props;
  if (!hasGoal) {
    return null;
  }

  return (
    <div className="NewFinancialPlan_retirement">
      <MobileTopNavSmallView onClick={() => window.history.back()} headerText="Health Care" />
      <div className="mobile-content-scrollable-small-topnav-gray">
        <MobileExplanations clientId={clientId} />
        <div className="mobile-consumer-heading-separator">{chartTitle}</div>
        <section className="chart mobile no-padding-bottom less-padding-left less-padding-right">
          <div className="mobile-recommended-target-amount-wrapper">
            <MobileHealthCareChart clientId={clientId} Data={chartData} loaded />
          </div>
        </section>
        <MobileActionStepsV2 clientId={clientId} fpId={fpId} />
        <MobileEditGoalButton clientId={clientId} fpId={fpId} />
      </div>
    </div>
  );
};

MobileEducationView.propTypes = {
  hasGoal: PropTypes.bool.isRequired,
  chartTitle: PropTypes.string.isRequired,
  chartData: PropTypes.shape({}).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  fpId: createCustomPropType(isUuid).isRequired,
};

export default MobileEducationView;
